import React, { useState } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import useDataHotels from '../../../../../dataHooks/useDataHotels'

export default ({
  hotel = {},
  onClose,
  onSuccess,
}) => {

  const {
    deleteHotel,
  } = useDataHotels()

  const [isBusy, setIsBusy] = useState(false);

  const onClickSubmit = async () => {
    if (!isBusy) {
      setIsBusy(true)

      try {
        await deleteHotel(hotel)

        setIsBusy(false)

        onSuccess()
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Confirm'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Delete Reservation'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        {'Are you sure you wish to delete this reservation?'}
      </div>
    </Modal>
  )
}